import { Link } from "react-router-dom";
import { Enso } from "./SacredGeometry";

export const Footer = () => (
  <footer className="border-t border-gold/12 bg-sanctuary-deep mt-24" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <Enso className="w-8 h-8 text-gold" />
          <span className="font-display text-xl text-parchment">Reiki Sanctuary</span>
        </div>
        <p className="text-text-muted text-sm leading-relaxed max-w-xs">
          A digital temple for the study of Usui Shiki Ryoho, from the first breath of Shoden to the mastery of Shihan.
        </p>
      </div>
      <div>
        <div className="eyebrow mb-4">The Path</div>
        <div className="flex flex-col gap-2 text-sm text-text-muted">
          <Link to="/courses" className="hover:text-gold transition-colors">Curriculum</Link>
          <Link to="/membership" className="hover:text-gold transition-colors">Membership</Link>
          <Link to="/login" className="hover:text-gold transition-colors">Enter the Sanctuary</Link>
        </div>
      </div>
      <div>
        <div className="eyebrow mb-4">The Lineage</div>
        <p className="text-text-muted text-sm leading-relaxed">
          Mikao Usui → Chujiro Hayashi → Hawayo Takata → the teachers of today.
        </p>
        <p className="font-jp text-gold/50 text-xs mt-4 tracking-widest">臼井靈氣療法</p>
      </div>
    </div>
    <div className="text-center text-text-dim text-xs py-6 border-t border-gold/10">
      © {new Date().getFullYear()} Reiki Sanctuary · Offered with gratitude and love
    </div>
  </footer>
);
